<template>
  <div class="pol-pod-drill-through-main">
    <div class="drill-through-body">
      <TableBox :title="tableTitle" :tableData="drillThroughDetails" :selectedRow.sync="selectedItem" :maxSelection="-1" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
    Tabulator
  },
  props: {
    drillThroughDetails: { type: Array, default: function() { return [] } },
    drillThroughType: { type: String, default: '' },
    tableTitle: { type: String, default: '' },
  },
  methods: {
  },
  mounted() {
    var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
    this.drillThroughDetails = details.data;
    this.drillThroughType = this.$route.params.drillThroughName.split('-')[1].trim().split(' ')[0].trim();

    if (details.port) {
      this.tableTitle = `${this.drillThroughType} TEUs jobs for ${details.port}`;
    } else {
      this.tableTitle = `${this.drillThroughType} TEUs summary by customer for ${details.country}`;
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.pol-pod-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;

  > .drill-through-body {
    background-color: white;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>